<template>
  <v-container class="px-0">
    <v-row no-gutters>
      <v-col>
          <v-row no-gutters>
            <v-col class="d-flex mb-1">
              <v-btn class="mx-2" color="secondary" small @click="refreshSearch"
                ><v-icon>{{mdiRefresh}}</v-icon>{{ $t("label.refresh") }}</v-btn
              >
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <v-tabs background-color="#009964" center-active dark v-model="tab">
            <v-tab key="warehouseTab1">{{ $t("label.all") }}</v-tab>
          </v-tabs>
          <v-tabs-items v-model="tab" touchless>
            <v-tab-item key="warehouseTab1">
              <v-card flat>
                <v-data-table
                  :headers="warehouseHeaders"
                  :items="warehouses"
                  :items-per-page="10"
                  item-key="CenterNo"
                  class="elevation-1"
                  :single-expand="true"
                  show-expand
                >
                  <template v-slot:expanded-item="{ headers, item }">
                    <td :colspan="headers.length" class="mx-0 px-0">
                      <v-card flat>
                        <v-card-text class="py-0 font-weight-bold">{{
                          item.Name
                        }}</v-card-text>
                        <v-card-text class="py-0">{{
                          item.Address
                        }}</v-card-text>
                        <v-card-text class="py-0">{{
                          item.CityName
                        }}</v-card-text>
                        <v-card-text class="py-0">{{
                          item.OpeningHours
                        }}</v-card-text>
                        <v-card-text class="py-0">{{
                          item.Description
                        }}</v-card-text>
                      </v-card>
                    </td>
                  </template>
                </v-data-table>
              </v-card>
            </v-tab-item>
          </v-tabs-items>

      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {mdiRefresh} from "@mdi/js";
import i18n from "../lang/lang";
import { SelectServiceCenter } from "@/api/publicServices";
export default {
  //集運倉
  metaInfo: {
    title: "集運倉",
    titleTemplate: "%s | 控制台 | 青蛙集運",
  },
  data: () => ({
    title: "label.warehouse",
    tab: null,
    warehouses: [],

    //svg icons
    mdiRefresh,
  }),
  components: {},
  methods: {
    async refreshSearch() {
      try {
        const response = await SelectServiceCenter({
          CenterType: "ORIGIN_WAREHOUSE",
        });
        this.warehouses = response.data;
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  computed: {
    warehouseHeaders() {
      return [
        { text: i18n.t("label.center_no"), value: "CenterNo" },
        { text: i18n.t("label.country"), value: "CountryName" },
        { text: i18n.t("label.name"), value: "Name" },
        { text: i18n.t("label.address"), value: "Address" },
      ];
    },
  },
  mounted() {
    this.refreshSearch();
  },
};
</script>
